import { CURRENCY } from "@pages/shippingView/config";
import { fieldMap } from "./helpers/map-cargo-packing";

export const TRANSPORT_REASON = [
  { id: "IMPORT", label: "Importazione" },
  { id: "STORAGE", label: "Conto deposito" },
  { id: "SALE", label: "Conto vendita" },
  { id: "PROCESSING", label: "Conto lavoro" },
  { id: "TRANSFER", label: "Trasferimento" },
  { id: "INSPECTION", label: "Conto visione" },
];
export const INCOTERMS = [
  "EXW",
  "FCA",
  "CPT",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
  "CFR",
  "DAT",
  "DDU",
];

export const EDITABLE_FIELDS: (keyof typeof fieldMap)[] = [
  "NUMBER",
  "THICKNESS",
  "WIDTH",
  "LENGTH",
  "GRADE",
  "HEAT",
  "NOTE1",
  "NOTE2",
  "PILE",
  "ROW",
  "TIERS",
  "DEPOSIT_REFERENCE",
  "DEPOT",
  "CLAIMS",
  "NOTE",
  "WEIGHING_NUMBER",
  "WEIGHING_POSITION",
  "CUSTOMS_PROCEDURE",
  "WAREHOUSE_YARD",
  "SECTOR",
  "HS_CODE",
  "CAAD_ADDITIONAL_CODE",
  "A14",
  "CUSTOMS_BILL_DRAFT",
  "DDT_CUSTOMS_REFERENCE",
  "CUSTOMS_BILL_DRAFT_INTRO",
];

export const NUMERIC_FIELDS: (keyof typeof fieldMap)[] = [
  "NET_WEIGHT",
  "GROSS_WEIGHT",
  "INVOICE_VALUE_CURRENCY_PER_TON",
  "INSURANCE",
];

export const DYNAMIC_AUTOCOMPLETE_FIELDS: (keyof typeof fieldMap)[] = [
  "SENDER_DEPOSITOR",
  "CONSIGNEE",
  "DESTINATION",
];

export const AUTOCOMPLETE_FIELDS: (keyof typeof fieldMap)[] = [
  "INVOICE_VALUE_CURRENCY",
  "INCOTERM",
];

export const DATE_FIELDS: (keyof typeof fieldMap)[] = ["A14_DATE"];

export const FIELDS_DEPENDENT_ON_TRANSPORT_DOCUMENT: (keyof typeof fieldMap)[] =
  ["DATE_DELIVERY", "CARRIER", "MEANS_OF_TRANSPORT"];

export const staticAutocompleteFieldConfig = {
  INVOICE_VALUE_CURRENCY: {
    field: "invoice_currency",
    options: CURRENCY,
  },
  INCOTERM: {
    field: "incoterm",
    options: INCOTERMS,
  },
};

export const autocompleteFieldConfig = {
  TERMINAL_OF_DISCHARGE: {
    field: "discharge_terminal_id",
    endpoint: "/api/terminals",
    query: "name",
  },
  WAREHOUSING: {
    field: "warehouse_id",
    endpoint: "/api/warehouses",
    query: "name",
  },
  SENDER_DEPOSITOR: {
    field: "depositor_id",
    endpoint: "/api/customers/names",
    query: "name",
  },
  CONSIGNEE: {
    field: "consignee_id",
    endpoint: "/api/customers/names",
    query: "name",
  },
  DESTINATION: {
    field: "destination_id",
    endpoint: "/api/customer-addresses",
    query: "destination",
  },
};

export const packingFilter = [
  {
    section: "Cargo Details + Tracking",
    filters: [
      { id: "customer", label: "Customer" },
      { id: "importer", label: "Importer" },
      { id: "supplier", label: "Supplier Of The Goods" },
      { id: "producer", label: "Mill Installation" },
      { id: "producer_mill", label: "Mill Operator" },
      { id: "bill_of_lading", label: "Bill of Lading" },
      { id: "vessel", label: "Vessel" },
      { id: "commodities", label: "Commodities" },
      { id: "production_method", label: "Production Method" },
      { id: "id_number", label: "ID Number" },
      { id: "thickness", label: "Thickness" },
      { id: "width", label: "Width" },
      { id: "length", label: "Length" },
      { id: "pieces", label: "Pieces" },
      { id: "net_weight", label: "Net Weight" },
      { id: "gross_weight", label: "Gross Weight" },
      { id: "grade", label: "Grade" },
      { id: "heat", label: "Heat" },
      { id: "comment_1", label: "Note 1 (DDT)" },
      { id: "comment_2", label: "Note 2 (DDT)" },
      { id: "ddt_customer_reference", label: "DDT Customer Reference" },
      { id: "customer_reference", label: "Customer Reference" },
      { id: "container", label: "Container" },
    ],
  },
  {
    section: "Customs",
    filters: [
      { id: "hs_code", label: "HS code" },
      { id: "caad", label: "Cadd additional code" },
    ],
  },
  {
    section: "FCR",
    filters: [
      { id: "fcr", label: "FCR" },
      { id: "fcr_status", label: "FCR Status" },
    ],
  },
  {
    section: "Unloading/Warehousing",
    filters: [
      { id: "terminal", label: "Terminal of Discharge" },
      { id: "deposit_reference", label: "Deposit Reference" },
      { id: "warehousing", label: "Warehousing" },
      { id: "pile", label: "Pile" },
      { id: "row", label: "Row" },
      { id: "tiers", label: "Tiers" },
      { id: "depot", label: "Depot" },
      { id: "note", label: "Note" },
      { id: "claims", label: "Claims" },
      { id: "marks", label: "Marks" },
      { id: "sender", label: "Sender/Depositor" },
      { id: "consignee", label: "Consignee" },
      { id: "destination", label: "Destination" },
      { id: "delivery_info", label: "Loading Order" },
      { id: "loading_ddt_created", label: "DDT Date" },
      { id: "transport_reason", label: "Reason of Transport" },
    ],
  },
  {
    section: "Delivery",
    filters: [
      { id: "transport_contactor", label: "Transport Contractor" },
      { id: "delivery_status", label: "Status" },
      { id: "loading_ddt", label: "DDT" },
      { id: "truck_supplier", label: "Carrier" },
      { id: "truck_kind", label: "Means of Transport" },
    ],
  },
];
